export default {
  meeting:{
    applyrecurring: 'Changes will apply to the new recurring schedule. Past meetings will remain unchanged.',

    recurrenceDescribeTwo: 'Occurs every {loopPulse} week(s) on {week} starting {start} until {end}',
    wanttodeletethemeetingfollowTwo: 'Delete the selected meeting and all following recurring meetings?',

    loopCycleSelectTips: 'Please select the day of the week to repeat.',

    export: 'Export',
    exportMeetingFileFuncTipsTitle: 'Export Confirmation',
    exportMeetingFileFuncTipsContentOne: 'No filters are applied. The system will export meeting records for the current year by default.',
    exportMeetingFileFuncTipsContentTwo: 'To export meetings from a different time period, please apply the desired filters before exporting.',

    myMeetingSearch: 'My Meetings',
    meetingTimeSearch: 'Meeting Time',
    meetingRoomsSearch: 'Meeting Room',

    Recurring:'Recurring:',
    wanttodeletethemeetingfollow: 'Are you sure you want to delete this and all following meetings?',

    endTimeCannotBeforeBeginTime: 'End date cannot be earlier than start date',
    Thismeeting: 'This meeting',
    Recurringmeeting: 'Recurring meeting',
    Checkin: 'Check-in:',
    checkinTip: 'After enabling, participants can check in by scanning the Room Scheduler QR code.',
    Recurrence_Setrecurrence: 'Set recurrence',
    Recurrence_Start: 'Start',
    Recurrence_RepeatEvery: 'Repeat every',
    Recurrence_Week: 'Week',
    Recurrence_end: 'End',
    recurrenceDescribe: 'Occurs every {week} starting {start} until {end}',
    Recurrence_DoesnotRepeat: 'Does not Repeat',
    Recurrence_Weekly: 'Weekly',

    AddressBookUser: 'User',
    AddressBookPhonebook: 'Address Book',
    RoomByPeopleNum1: '2 or fewer people',
    RoomByPeopleNum2: '3-6 people',
    RoomByPeopleNum3: '7-10 people',
    RoomByPeopleNum4: '11-15 people',
    RoomByPeopleNum5: '16-20 people',
    RoomByPeopleNum6: '21-30 people',
    RoomByPeopleNum7: 'More than 30 people',

    whoAreBound: 'Users who are bound to a system account will see the meeting in the system calendar. Users who have provided an email address will receive meeting notifications via email. To receive email notifications, please complete your email information in [My Profile].',

    AttendessMeeting: 'Attendees:',
    SelectAttendessMeetingTip: 'Select Attendees',

    MeetingFilter: 'Meeting Filter',
    HostedbyMe: 'Hosted by Me',
    Invitedby: 'Invited by Me',
    Otherby: 'Others',

    "AddressIsDuplicated": "Contact email is duplicated",
    meetingExpired:'Expired',
    titlePhoneFormat: 'Phone can only fill in numbers, () + and -.',
    "selectField": "Please select a file",
    "Limit255": "The file name cannot exceed 255 characters",
    "nameLimit25": "The name cannot exceed 25 characters",
    "emailLimit50": "The email cannot exceed 50 characters",
    "emailFormatError": "Please enter a valid email address",
    "phoneLimit11": "The phone number can contain up to 11 digits",
    "ParticipantsEmail": "Participant Email:",
    "listIsEmpty": "The list is empty",
    "Startimporting": "Start Upload",
    "Selectfile": "Select File",
    "Importfile": "Import File",
    "ImportfileTip": "*Only Outlook-format CSV (.csv) or vCard (.vcf) files are supported for import.",
    "addParticipants": "Add Participant",
    "multiselectdeselect": "Tag deletion hint",
    "multiselectselected": "Selected hint",
    "enterOrSelectALabel": "Select participant email",
    "deleTitleContact": "Are you sure you want to delete this contact?",
    "delTitleContactContent": "Delete contact?",
    "deleteContactTitle": "Please select the contact you want to delete",
    "editcontact": "Edit Contact",
    "Name": "Name",
    "email": "Email",
    "telephoneNumber": "Phone",
    "Addcontact": "Add Contact",
    "Importcontactfile": "Import Contacts",
    "AddressBook": "Address Book",
    "Participants": "Participants:",

    bindTipContent:'This organization has already bound a third-party calendar. Please schedule meetings via Outlook/Teams.',
    Productupdatenews:'A new version update has been released. ',
    bookingPerson: 'Booked By',
    DeleteMeeting:'Delete Meeting',
    wanttodeletethemeeting:'Do you want to delete the meeting?',
    hasbeendeleted:'The meeting has been deleted',
    theMeetingWasAborted:'End Meeting Early',
    theMeetingWasAbortedContent:'Do you want to end the meeting early?',
    determineTheAbortTask:'End Meeting Early',
    theMeetingEndedEarly:'The meeting has ended early.',
    with:'with',
    Other:'Other',
    tasks:'tasks',
    conflict:'conflict',
    meetConflicts:' The following meeting time conflicts :',
    itIsNotAllowedToSelectThePastTime:'Past times cannot be selected',
    selected:'Selected',
    noOverFive:'Select no more than 5 meeting rooms',
    approvalOpinions:'Approval Opinions',
    beyondTheTimeLimitItCannotBeSelected:'Beyond the time limit, it cannot be selected',
    startMonth:'Start Month',
    to:'to',
    stopMonth:'End Month',
    didnTStart:'Not Started',
    ONGOING:'Ongoing',
    ENDED:'Ended',
    hasBeen:'has Been',
    booking:'booking',
    Approval:'Approval',
    MeetingRoom:'Meeting Room',
    AllRoom:'All Room',
    Available:'Available',
    Initiate:'Initiate Meeting',
    MeetingApproval:'Meeting Approval',
    PreviousMonth:'Previous Month',
    Today:'Today',
    NextMonth:'Next Month',
    YearMonth:'Year/Month',
    TimeDisplay:'Time Display',
    MeetingTitleAbbreviation:'Meeting Title Abbreviation',
    InitiateMeeting:'Initiate Meeting',
    PendingMeetings:'Upcoming Meetings',
    AllMeetings:'All Meetings',
    noMeetings:'There are no meetings to attend at the moment',
    NotStarted:'Not Started',
    Organizer:'Organizer',
    MeetingDateTime:'Date & Time',
    MeetingLocation:'Location',
    MeetingSubject:'Meeting Subject',
    Invited:'Invited',
    PeopleAccepted:'People Accepted',
    EditMeeting:'Edit Meeting',
    CancelMeeting:'Cancel Meeting',
    InitiateEditMeeting:'Initiate/Edit Meeting',
    Subject:'Subject',
    Presenter:'Presenter : ',
    DateTime:'Date & Time',
    TimeAndZone:'Time Zone',
    Attendees:'Attendees',
    Addrequiredattendees:'Add required attendees',
    SelectRooms:'Select Rooms',
    Reminder:'Reminder',
    Remindbeforestart:'Remind before start',
    Confirm:'Confirm',
    topic:'Subject : ',
    topicplace:'New meeting title:',
    speaker:'Presenter : ',
    speakerplace:"Please enter the presenter's information",
    DateAndTime:'Date&Time : ',
    TimeZone:'Time Zone',
    EndDate:'End date',
    Rooms:'Rooms : ',
    Notes:'Notes : ',
    MeetingRoomApproval:'Meeting Room Approval',
    PendingApproval:'Pending Approval',
    Approved:'Approved',
    nopendingapprovals:'There are no pending approvals',
    Applicant:'Applicant',
    UsageTime:'Usage Time',
    ApprovalResult:'Approval Result',
    ApprovalComments:'Approval Comments',
    Approve:'Approve',
    Reject:'Reject',
    Search:'Search',
    Filter:'Filter',
    scanTheQRCodeToSignIn:'Scan the QR code to sign in',
  },
  "NPS": {
    "Relay": "Relay",
    "RelaySettings": "Relay Settings",
    "DevicePower": "Device Power control",
    "DeviceElevation": "Elevation Control",
    "LinageWithNPSPower": "linkage with NPS Power",
    "PresentationSwitch": "Presentation Switch",
    "Duplicate": "Duplicate",
    "LinkagewithNPSPowe": "Linkage with NPS Powe",
    "npsTooltip": "USB Devices can only be called by PC host that is switched to HDMI OUT 1.",
    "nmpTooltip": "Click the 'Duplicate' button to mirror the screen content on other displays, synchronizing the display across multiple screens."
  },
  "textTemplate": {
    "template2513": "Fire emergence broadcasting",
    "template2514": "Please evacuate from the emergency exit and fire exit to a safe place according to the fire escape plan.",
    "moreTemplate": "Template limit reached",
    "add": "Add",
    "SetTemplate": "Set Template",
    "Emergency": "Emergency",
    "General": "General",
    "BroadcastDevices": "Broadcast Device:",
    "selectBroadcastDevices": "Please select broadcast devices",
    "All": "All",
    "AddTemplate": "Add Template",
    "EditTemplate": "Edit Template",
    "deleteTemplage": "Are you sure you want to delete the selected template?",
    "title": "Delete Template",
    "selectTemplage": "Please select a template!",
    "DeleteCancelled": "Delete cancelled!",
    "DeletedSuccessfully": "Deleted successfully!",
    "noData": "No template can be used, click on the upper right corner to add a template.",
    "TemplateTitle": "Template Title:",
    "BroadcastType": "Broadcast Type:",
    "BroadcastTypeDialog": "Broadcast Type:",
    "selectBroadcastType": "Please select broadcast type",
    "BroadcastDuration": "Broadcast Duration:",
    "BroadcastDevice": "Broadcast Device:",
    "BroadcastContent": "Broadcast Content:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "Error!",
    "mediaTimeStateNotifyErrorContent": "Your streaming service has expired, please contact your agent to renew in time.",
    "mediaTimeStateNotifyWarnTitle": "Attention!",
    "mediaTimeStateNotifyWarnContent": "You are currently in the trial state that only can push broadcasting and live streaming to 3 terminal devices at most.",
    "mediaTimeStateNotifySuccessTitle": "Successful Renewal",
    "mediaTimeStateNotifySuccessContent": "Your streaming service is ready for normal use. Thank you.",
    "company": "Company Name:",
    tableAddress:'Address:',
    createTime:'CreateTime:',
    "email": "Email:",
    "phone": "Phone:",
    "Trial": "Trial",
    "TrialWorkstation": "You are currently in the trial state that only can push broadcasting and live streaming to 3 terminal devices at most.",
    "Normal": "Normal",
    "NormalWorkstation": "The valid period of your streaming service is from ",
    "to": "to",
    "Advent": "Advent",
    "AdventWorkstationOne": "Your streaming service will expire on ",
    "AdventWorkstationTwo": ", please contact your agent to renew in time for normal use.",
    "Expired": "Expired",
    "ExpiredWorkstation": "Your streaming service has expired, please contact your agent to renew in time."
  },
  "route": {
    "dashboard": "Dashboard",
    "i18n": "I18n",
    "Devices": "Devices",
    "Broadcast": "Broadcast",
    "Schedule": "Schedule",
    "Resources": "Resources",
    "Live": "Streaming",
    "meetings": "Meeting",
  },
  "navbar": {
    "updates":"Latest Updates",
    "logOut": "Log Out",
    "screenfull": "screenfull",
    "oprofile": "My Profile",
    "settings": "Settings",
    "language": "Language",
    "BackTianwa": "Back to Tianwa",
    "newUserGuide": "New User Guide"
  },
  "feedback": {
    "Feedback": "Feedback",
    "email": "Please leave your email for our feedback.",
    "content": "Welcome and leave messages for improving our products. Thanks for your comments.",
    "submit": "Submit",
    "emailNoEmpty": "E-mail can not be empty",
    "emailTrueRule": "Please enter the correct email format",
    "contentNoEmpty": "The content can not be blank",
    "feedbackSuccess": "Feedback success",
    "feedbackFailed": "Feedback failed",
    "emailNoChinese": "Mailbox cannot have Chinese characters",
    "emailLength": "Between 5 and 50 characters in length",
    "emailSpecialString": "Mailbox cannot contain special strings"
  },
  "login": {
    checkPasswordTitleTwo: 'Please set a password of at least 6 characters, including letters and numbers. Special characters are allowed (no restrictions).',
    captcha: 'Verification Code',
    checkPasswordTitle: 'Password must be at least 6 characters and cannot be all numbers',
    "title": "WELCOME",
    "logIn": "Log in",
    "consoleLogin": "Console Log In",
    "username": "Username",
    "password": "Password",
    "any": "any",
    "thirdparty": "Or connect with",
    "thirdpartyTips": "Can not be simulated on local, so please combine you own business simulation! ! !",
    "placeholder": ["User Name", "Password", "Vercode"],
    "userNameTitle": "Wrong username!",
    "forget": "Forgot it?",
    "loginTitle0": "Log in successfully!",
    "loginTitle1000": "Wrong user name or password!",
    "loginTitle1001": "Username and password must be filled!",
    "loginTitle1002": "Verification code must be filled!",
    "loginTitle1003": "User status is illegal, login failed!",
    "loginTitle1004": "Verification code error!",
    "loginTitle1005": "Not logged in, please login first!",
    "loginTitle1006": "The two passwords are different!",
    "loginTitleUserName": "Username must be filled!",
    "loginTitlePwd": "Password must be filled!",
    "loginTitleVercode": "Verification code must be filled!",
    "titleLoginNameFormat": "Account must consist of characters, or characters and numbers.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "Devices",
    "btnRoadcast": "Broadcast",
    "btnResources": "Resources",
    "btnLive": "Streaming",
    "meetings": "Meeting",
    "todaySchedule": "Today Schedule",
    "allSkedules": "All Schedules",
    "details": "Details",
    "btnStart": "Start",
    "titleContent": "Greetings! Q-NEX Console is at your service. Let's get started!",
    "btnExit": "Exit"
  },
  "devices": {
    ptzCamera:'PTZ Camera',
    "start": "START",
    "stop": "STOP",
    "nmpPowerOff_mandatory": "In broadcasting (non-mandatory)",
    "nmpPowerOff_nomandatory": "In broadcasting (non-mandatory). Continue execution?",
    "nmpsPowerOff_mandatory": "Some NMPs are in broadcasting (mandatory).",
    "nmpsPowerOff_nomandatory": "Some NMPs are in broadcasting (non-mandatory). Continue execution?",
    "reset": "Reset",
    "displayedInTheControlArea": "Displayed in the control center",
    "dragOrder": "Drag order",
    "areaSettingTwoNotice": "*RS232, AC control, and remote control are displayed in the control center depending on NMP binding status in the dashboard.",
    "areaSettingThreeNotice": "*CBX control is displayed in the control center depending on NMP binding status in the dashboard.",
    "controlSet": "Control center setting",
    "vcbNoLine": "No CBX device is online",
    "vcbNoBound": "No CBX device is bound",
    "tscNoBound": "RS232 on TSC is not bound to any data. Please notify the administrator to bind it in the dashboard.",
    "light": "Power Control",
    "vcbpower": "Power",
    "rs232Control": "Serial Control",
    "CBX": {
      "powerSupplyON": "Power On",
      "powerSupplyOFF": "Power Off",
      "lockScreenON": "Lock On",
      "lockScreenOFF": "Lock Off",
      "childLockON": "Child lock On",
      "childLockOFF": "Child lock Off",
      "energySavingON": "Energy saving On",
      "energySavingOFF": "Energy saving Off",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "Speaker",
      "brightAdjustment": "Brightness",
      "other": "Other features..."
    },
    "InterfaceOne": "Interface One",
    "InterfaceTwo": "Interface Two",
    "abcStyleP": "Sorry! TSC and (NMP,MBX,NPS,NDP100,NDP500) cannot be selected at the same time",
    "masterControl": "main",
    "powerSupply": "Power",
    "RecordingControl": "Recording Control",
    "RecordingControlSystem": "Lecture Capture System",
    "LiquidCrystal": "Interactive LCD Display",
    "projector": "Projector",
    "othertype": "Other",
    "lockScreen": "Lock",
    "childLock": "Child lock",
    "energySaving": "Energy saving",
    "signalSourceSwitching": "Input Source",
    "volumeAdjustment": "Speaker",
    "brightAdjustment": "Brightness",
    "other": "Other features",
    "otherFunction": "Function",
    "send": "Send",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "Air Conditioner",
    "titleDevices": "Groups Filter:",
    "content": "Search",
    "selectALL": "Select ALL",
    "SelectRecentPage": "Select Current Page",
    "controlPanel": "Control Center",
    "displayInputSwitch": "Display Input Switch",
    "chooseINPUTSources": "Choose INPUT Sources",
    "speakerVolume": "Audio Volume",
    "bass": "Bass",
    "treble": "Treble",
    "MICVolume": "MIC Volume",
    "AirConditioning": "Air Conditioner",
    "model": "Model",
    "setTemp": "Set Temp",
    "fanSpeed": "Fan Speed",
    "bold": "Swing",
    "projectionScreen": "Projection Screen",
    "electronicLock": "Electric Lock",
    "electronicLock1": "Electric Lock",
    "selectDevices": "Please select a device or a group of devices",
    "isCompelType": "Device control unavailable due to mandatory broadcast, please try again later.",
    "mainPower": "Main Power",
    "extraPower": "Extra Power",
    "power": "Power",
    "hdmiBroadcast": "Broadcast",
    "equipmentState1": "Power On",
    "equipmentState2": "Power Off",
    "equipmentState3": "Offline",
    "main": "Main",
    "external": "External",
    "ProjectionScreen": "Projection Screen",
    "UP": "UP",
    "DOWN": "DOWN",
    "LOCK": "LOCK",
    "UNLOCK": "UNLOCK",
    "PleaseDevice": "Please select device(s) on the left",
    "RemoteControl": "Remote Control",
    "Action": "Action",
    "Devicefilter": "Device filter",
    "DeviceStatus": "Status",
    "DeviceType": "Type",
    "currentAudioSource": "Current audio source",
    "audioSwitching": "Audio Output Switch"
  },
  "broadcast": {
    "isBoarding": "(In Broadcasting)",
    "last3Days": "LAST 3 DAYS",
    "last7Days": "LAST 7 DAYS",
    "last30Days": "LAST 30 DAYS",
    "historyRecord": "History",
    "SelectDestination": "1.Select Destination",
    "BroadcastingConsole": "2.Broadcasting Console",
    "Notification": "Notification",
    "btnStop": "Stop",
    "btnStart": "Start",
    "Letters60": "(less than 60 Letters)",
    "Letters300": "(less than 300 Letters)",
    "LastingTime": "Lasting Time:",
    "Title": "Title:",
    "Content": "Content:",
    "Cannotquit": "Mandatory Broadcast",
    "ChooseMedia": "Select A Media File",
    "Broadcasting": "Broadcasting",
    "dialogTitle": "Video&Audio Resources",
    "SortBy": "Sort by",
    "btnBake": "Back to previous",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "save": "Save",
    "coxAll": "All",
    "PublicCloud": "Public Storage",
    "IndividualCloud": "Personal Storage",
    "selFile": "Please select a file or a group.",
    "StopBroadcast": "Stop Broadcast",
    "StartBroadcasting": "Start Broadcasting",
    "StopBroadcasting": "Stop Broadcasting",
    "ForceQuit": "Force quit",
    "PleaseMediaFile": " Please select a media file",
    "PleaseDevice": " Please select a device",
    "broadcast_0": "Start Broadcasting",
    "broadcast_2500": "Exceeds the maximum number of connectable devices for the Media Server",
    "broadcast_2501": "Broadcast file error",
    "broadcast_2502": "Broadcasting Ended",
    "broadcast_2503": "Unable to obtain Media Server information",
    "broadcast_2510": "Attention! You are currently in the trial state, Up to 3 terminal devices can receive broadcasting commands, Please check the number of devices you have chosen.",
    "broadcast_2018": "Streaming service is shut down",
    "broadcast_2019": "Streaming service has expired",
    "broadcast_2512": "Exceed the limit of templates quantity.",
    "broadcast_2513": "Fire emergence broadcasting",
    "broadcast_2514": "Please evacuate from the emergency exit and fire exit to a safe place according to the fire escape plan.",
    "broadcast_2006": "Device doesn’t found",
    "broadcast_2": "The disk service is abnormal",
    "broadcast_2515": "Select a device that doesn't have broadcast capabilities",
    "broadcast_2516": "Select files that exceed the maximum supported resolution of NMP",
    "broadcast_2517": "Select files that exceed the maximum supported resolution of NDP500",
    "broadcast_Title": "Broadcasting Alert.",
    "broadcast_TitleNDP500": "NDP500 Broadcasting Alert",
    "broadcast_content": "Device supports up to 4K@30FPS, with its optimal resolution being 1080P@30FPS.",
    "broadcast_contentNDP500": "NDP500/600 supports up to 1080P@30FPS, with its optimal resolution being 720P@30FPS.",
    "broadcast_noSupported": "The following selected videos are not supported for broadcasting:",
    "broadcast_noSupportedNDP500": "The following selected videos are not supported for broadcasting on NDP500/600:"
  },
  "resources": {
    "uploadNameLengthError": "Upload file name cannot exceed 100 words!",
    "onUploadFile": "No files to upload",
    "open": "Open",
    "fold": "Fold",
    "close": "Close",
    "PublicCloud": "Public Storage",
    "IndividualCloud": "Personal Storage",
    "TransfersHistory": "Transfers History",
    "btnDownload": "Download",
    "btnDelete": "Delete",
    "btnUploadFile": "Upload File",
    "btnNewFolder": "New Folder",
    "btnBake": "Back to previous",
    "coxAll": "All",
    "uploadError": "The upload file size cannot exceed 1G!",
    "MD5": "Verify MD5",
    "merge": "Merging",
    "transcoding": "Transcoding",
    "uploadFailed": "Upload Failed",
    "fileError": "File read error, please check the file.",
    "tableName": "Name",
    "tableSize": "Size",
    "tableType": "Type",
    "tableTimeAdded": "Time Added",
    "tableAction": "Action",
    "btnRename": "Rename",
    "btnMoveTo": "Move to...",
    "ClearAll": "Clear All",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "save": "Save",
    "addSuccess": "Add Successfully!",
    "addError": "Fail to Add!",
    "editSuccess": "Edit Successfully!",
    "editError": "Fail to Edit!",
    "delSuccess": "Delete Successfully!",
    "delError": "Fail to Delete!",
    "diskError3000": "Exceeded the total space size, operation failed!",
    "diskError3001": "Exceeded the amount of the public space used, the operation failed!",
    "diskError3002": "Exceeded the amount of the individual space used, the operation failed!",
    "diskError3003": "Can't find the data, please check if the media server is bound!",
    "diskError3004": "The folder name already exists!",
    "diskError3005": "Failed to get the folder!",
    "diskError3006": "At the same level, you can't create more than 99 folders!",
    "diskError3007": "The same file name exists and the modification failed!",
    "diskError3008": "The same folder name exists and the modification failed!",
    "diskError3009": "The file exceeds the remaining space and the upload failed!",
    "diskError3010": "Failed to upload!",
    "diskError3011": "File verification failed, please re-upload the file!",
    "diskError3012": "Failed to get private cloud address, operation failed!",
    "diskError3013": "Multiple file combinations can't exceed 100M, large files please download separately!",
    "diskError3014": "Compression failed, please re-select file download!",
    "diskError3015": "You need permission to perform this action",
    "downloadError": "Download failed!",
    "mobileError": "Move failed!",
    "root": "All files",
    "Name": "Name",
    "Size": "Size",
    "Type": "Type",
    "uploadFile": "Upload File",
    "newFolder": "New Folder",
    "tableTime": "Time",
    "permission": "Insufficient permissions!",
    "notifyTitle": "Notification",
    "notifyContent": "The user has insufficient permissions to access it!",
    "sortFileName": "File Name",
    "sortTime": "Time",
    "sortSize": "Size",
    "sortType": "Type",
    "moveTo": "Move to",
    "test": "New",
    "delTitle": "Delete?",
    "delTitleContent": "The selected contents will be deleted from database. The operation cannot be undone. Are you sure you want to continue?",
    "delCancelButton": "Cancel",
    "delConfirmButton": "Confirm"
  },
  "userMge": {
    "userName": "User Name:",
    "jobNumber": "Employee ID:",
    "email": "Email:",
    "phone": "Phone:",
    "group": "Group:",
    "oldPassword": "Old Password:",
    "newPassword": "New Password:",
    "confirmNewPassword": "Confirm New Password:",
    "btnSave": "Save Change",
    "titleChangePassword": "Change Password",
    "titleMyProfile": "My Profile",
    "name": "Nickname:",
    "error1400": "Account (custom) already exists, operation failed!",
    "error1401": "Account (system generation) already exists, operation failed!",
    "error1402": "Group does not exist, import failed!",
    "error1403": "Data error",
    "error1404": "Insufficient permissions",
    "selUser": "Please select a user!",
    "error1405": "Failed to get role",
    "error1406": "Imported user information data format is incorrect",
    "error1407": "The email already exists and the operation failed.",
    "error1408": "The phone already exists and the operation failed.",
    "editSuccess": "Successfully saved!",
    "ChangePassword": "Change Password",
    "UserPrivacyAgreement": "User Privacy Policy"
  },
  "information": {
    "_2602": "Device Offline",
    "_2603": "Broadcasting failed",
    "_2604": "Broadcasting has been cut off",
    "_2605": "Storage space is full",
    "_2606": "minutes ago",
    "_2607": "hours ago",
    "_2609": "failed, please ",
    "_2609_a": "click here ",
    "_2609_time": "to deal with it in time",
    "userType": "Administrator",
    "unreadNoticeFirst": "Unread Notice First",
    "sortByTime": "Sort By Time",
    "coxRead_1": "Read",
    "coxRead_0": "Unread",
    "allCoxRead": "Mark all as read",
    "load": "Loading...",
    "noData": "No more data",
    "viewALLMessages": "View ALL Messages"
  },
  "input": {
    "select": "Please select",
    "thisField": "This field must be filled.",
    "titleShooleNub60": "less than 60 letters",
    "titleShooleNub300": "less than 300 letters",
    "Offline": "Offline"
  },
  "schedule": {
    "OnlyManual": "Only Manual",
    "runStartNow": "Run Task",
    "runStopNow": "Stop Task",
    "tackExecutionStart": "Task is running",
    "tackExecutionStop": "Task Execution Stopped",
    "dehumidification": "Dehumidification",
    "airSupply": "Air Supply",
    "masterControl": "main:",
    "powerSupply": "Power",
    "lockScreen": "Lock",
    "RecordingControl": "Recording Control",
    "RecordingControlSystem": "Lecture Capture System",
    "LiquidCrystal": "Interactive LCD Display",
    "projector": "Projector",
    "othertype": "Other",
    "childLock": "Child lock",
    "energySaving": "Energy saving",
    "signalSourceSwitching": "Input source",
    "other": "Other features:",
    "otherFunction": "Function",
    "send": "Send",
    "ON": "ON",
    "OFF": "OFF",
    "btnAddSchedule": "Restore",
    "EditSchedulelist": "Edit Scheduler",
    "AddSchedulelist": "Add Scheduler",
    "RestoreSchedulelist": "Restore",
    "btn": "Cancel",
    "btnNewList": "New Scheduler",
    "ListName": "Name",
    "Cannotquit": "Mandatory",
    "NOCannotquit": "NO",
    "ListValidityPeriod": "Validity Period",
    "ListDescription": "Description",
    "currentSchedule": "Scheduler list",
    "historySchedule": "History list",
    "selectTime": "Time",
    "selectTimeTable": "Time",
    "taskType": "Task Type",
    "selectBroadcasting": "Broadcasting",
    "selectDeviveControl": "Device Control",
    "newSchedule": "New Task",
    "newChecklist": "New Checklist",
    "titleStatus": "Status",
    "titleType": "Type",
    "titleStartTime": "Start Time",
    "titleEndTime": "End Time",
    "titleRepeat": "Repeat",
    "titleName": "Name",
    "titleAction": "Action",
    "tableEnabled": "Enabled",
    "tablePaused": "Paused",
    "tableEdit": "Edit",
    "tableDelete": "Delete",
    "tableVolumeEdit": "Broadcast Volume",
    "tableBroadcastTitle": "Title",
    "tableBroadcastContent": "Content",
    "tableBroadcastList": "List",
    "tableBroadcast": "Compulsive",
    "btnRemoveCompletely": "Remove Completely",
    "btnEnabled": "Enabled Task",
    "btnPaused": "Disable Task",
    "btnDelete": "Delete",
    "repeat0": "MON",
    "repeat1": "TUE",
    "repeat2": "WED",
    "repeat3": "THU",
    "repeat4": "FRI",
    "repeat5": "SAT",
    "repeat6": "SUN",
    "dialogTitleAdd": "New Device Control Task",
    "dialogTitleEdit": "Edit Device Control Task",
    "newBroadcastingSchedule": "New Broadcasting Task",
    "editBroadcastingSchedule": "Edit Broadcasting Task",
    "chooseDevice": "Choose Device",
    "timeSetting": "Time Setting",
    "controlBroadcasting": "Broadcasting Option",
    "controlOption": "Control Option",
    "scheduleName": "Task Name:",
    "destination": "Destination",
    "timeTilte": "Time",
    "repeatTitle": "Repeat",
    "dialogRepeat0": "MON",
    "dialogRepeat1": "TUE",
    "dialogRepeat2": "WED",
    "dialogRepeat3": "THU",
    "dialogRepeat4": "FRI",
    "dialogRepeat5": "SAT",
    "dialogRepeat6": "SUN",
    "dialogOnceType": "Once",
    "dialogRepeatType": "Repeat",
    "Manual": "Manual",
    "ManualContent": "You may manually execute these tasks once you finish the configuration.",
    "mainPower": "Main Power",
    "powerControl": "Power Control",
    "tableDisplayInputSwitch": "Display Input Switch",
    "tableAirConditioning": "Air Conditioner",
    "tableProjectionScreen": "Projection Screen",
    "tableElectronicLock": "Electric Lock",
    "interactiveFlatPanel": "Interactive Flat Panel",
    "displayInputSwitch": "Display Input Switch",
    "speakerVolume": "Audio Volume",
    "MICVolume": "MIC Volume",
    "ProjectionScreen": "Projection Screen",
    "ElectronicLock": "Electric Lock",
    "AirConditioning": "Air Conditioner",
    "AirConditioningPower": "Power",
    "AirConditioningModel": "Model",
    "AirConditioningTEMP": "Temp",
    "AirConditioningFanSpeed": "Fan Speed",
    "OPEN": "OPEN",
    "CLOSE": "CLOSE",
    "UP": "UP",
    "DOWN": "DOWN",
    "PowerOFF": "OFF",
    "PowerON": "ON",
    "ModelAuto": "Auto",
    "ModelCool": "Cool",
    "ModelHeat": "Heat",
    "ModelAir": "Air-side",
    "TEMPLow": "Low",
    "TEMPMiddle": "Middle",
    "TEMPHigh": "High",
    "btnSave": "Save",
    "btnNext": "NEXT",
    "StartTime": "Start Time",
    "StopTime": "Stop Time",
    "Mandatory": "Mandatory",
    "Video": "Video&Audio",
    "Notification": "Notification",
    "btnFile": "Select A Media File",
    "LastingTime": "Lasting Time",
    "textTitle": "Title",
    "textContent": "Content",
    "textTitleLetters": "Less than 60 Letters",
    "textContentLetters": "Less than 320 Letters",
    "CannotquitYES": "YES",
    "CannotquitNo": "No",
    "YES": "YES",
    "No": "No",
    "delTitleContent": "Are you sure you want to delete this scheduler?",
    "delTitleListContent": "The deleted scheduler will be moved to the history list and can be restored",
    "deleListTitle": "Delete scheduler?",
    "delTitleListContent1": "Deleting the scheduler will cause the tasks associated with it to be cleared, please confirm.",
    "deleListTitle1": "Are you sure you want to delete this scheduler?",
    "delTitle": "Delete?",
    "btnConfirm": "Confirm",
    "coxAll": "ALL",
    "coxBroadcasting": "Broadcasting",
    "coxDeviveControl": "Device Control",
    "rdMandatory": "YES",
    "noRdMandatory": "NO",
    "startDate": "Start Date",
    "endedDate": "Ended Date",
    "or": "-",
    "broadcastingType": "Type",
    "ChooseTime": "Choose Time",
    "ChooseDate": "Choose Date",
    "newScheduleList": "New Scheduler",
    "editScheduleList": "Edit Scheduler",
    "listName": "Name",
    "listValidityPeriod": "Validity Period",
    "listDescription": "Description",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "save": "Save",
    "addSuccess": "Add Successfully!",
    "addError": "Fail to Add!",
    "editSuccess": "Edit Successfully!",
    "editError": "Fail to Edit!",
    "delSuccess": "Delete Successfully!",
    "delError": "Fail to Delete!",
    "restoreSuccess": "Schedule list restored successfully",
    "restoreError": "Schedule list recovery failed",
    "restoreTitleContent": "This time conflicts with the schedule time in the list, please select again",
    "Enabled": "Enabled",
    "Paused": "Paused",
    "Title": "Title:",
    "Content": "Content:",
    "errorScheduleNameRequired": "Task name must be filled",
    "errorDeviceRequired": "Please select the target device",
    "deleTitle": "Are you sure you want to delete this task?",
    "loopList": "Loop List",
    "errorPleaseDateRange": "Please select a date range",
    "addError_2009": "Duplicate scheduler name",
    "conflicts": "The task time conflicts with the following:",
    "Pleaseagain": "Please enter again",
    "errorScheduleName": "Task Name",
    "errorListName": "Scheduler Name",
    "today": "Today",
    "yesterday": "Yesterday",
    "thisWeek": "This week",
    "lastWeek": "Last week",
    "lastMonth": "Last month",
    "thisMonth": "This month",
    "times": "Times",
    "TimeConflicts": "Time Conflicts",
    "editError_2006": "Device doesn’t found",
    "editError_2010": " Duplicate task name",
    "editError_2100": "The task has expired, unable to start.",
    "ListTimeExpired": "Scheduler time has expired, please select again",
    "TimeExpired": "Time Expired",
    "ControlOption": "Control option is missing",
    "Pleaseleastone": "Please select at least one control option",
    "Enter": "Enter",
    "TitleFilled": "Title must be filled",
    "ContentFilled": "Content must be filled",
    "PleaseMediaFile": "Please select a media file",
    "PleaseSchedule": "Please select a task",
    "delTitleScheduleContent": "The deleted task cannot be recovered.",
    "deleTitleSchedule": "Are you sure to delete this task?",
    "deleteScheduleTitle": "Please select the task to delete",
    "PleaseFillColumn": "Please fill in the name of scheduler",
    "PleaseDate": "Please select the date",
    "Previous": "Previous",
    "RemoteControl": "Remote Control",
    "taskhasexpired": "This task has expired, please contact the creator to update the time.",
    "execute": "Execute",
    "broadcastingList": "Broadcasting List",
    "volumeSuccess": "Volume set successfully",
    "volumeFailed": "Volume set failed"
  },
  "live": {
    "StreamingRoom": "Streaming Room",
    "btnAddNewRoom": "Add New Room",
    "Steaming": "Streaming",
    "Creater": "host:",
    "Address": "RTMP Address:",
    "StreamingURL": "Live Streaming URL:",
    "DestinationNMP": "Select Destination NMP:",
    "stop": "STOP",
    "stat": "START",
    "btnCope": "Click to COPY",
    "QRcode": "QR Code",
    "Refresh": "Refresh",
    "AddNewRoomTitle": "Add New Streaming Room",
    "editNewRoomTitle": "Edit Streaming Room",
    "roomName": "Room name:",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "save": "Save",
    "delTitleContent": "Are you sure you want to delete this schedule?",
    "delTitle": "Delete?",
    "delCancelButton": "Cancel",
    "delConfirmButton": "Confirm",
    "addSuccess": "Add Successfully!",
    "addError": "Fail to Add!",
    "editSuccess": "Edit Successfully!",
    "editError": "Fail to Edit!",
    "delSuccess": "Delete Successfully!",
    "delError": "Fail to Delete!",
    "Stopstreaming": "Stop streaming",
    "Startstreaming": "Start streaming",
    "error2504": "Unable to obtain the live streaming address of the media server",
    "error2505": "Duplicate streaming room name",
    "error2506": "The device has been occupied by another streaming signal",
    "error1900": "The parameter accessed is empty",
    "error2503": "Unable to obtain media server information",
    "error2507": "Duplicated live streaming address",
    "copySuccess": "Content has been copied to the clipboard.",
    "copyError": "The browser does not support automatic copying",
    "flashControl": "Flash is not installed or enabled. Please try again after install or enable the Flash.\n",
    "liveStreaming": "No live streaming source found.",
    "btnflash": "Install/Enable",
    "serverAddress": "Server address",
    "addressKey": "Key:",
    "watchingAddress": "Watching address",
    "audioOnly": "Audio Only",
    "enterTheKey": "The key must be filled."
  },
  "guidepages": {
    "next": "Next-control device",
    "next1": "Next-try to control",
    "next2": "Next-broadcast",
    "next3": "Next-start broadcasting",
    "next4": "Next-stop broadcasting",
    "next5": "Next-text broadcast",
    "next6": "Next-task setup",
    "next7": "Next-add new task",
    "next8": "Next-history list",
    "next9": "Next-cloud storage",
    "next10": "Next-live streaming",
    "next11": "Next-set up live streaming",
    "exit": "Exit",
    "guideContent": "Guide content",
    "btnHomepage": "Home page",
    "btnDevices": "Devices",
    "btnBroadcast": "Broadcast",
    "btnSchedule": "Schedule",
    "btnResources": "Resources",
    "btnStreaming": "Streaming",
    "btnPrevious": "Previous"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js